import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-planet-line text-2xl text-primary-500"></i>
          </div>
          <span className="font-heading text-xl font-bold text-foreground-950">
            星球漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
              location.pathname === '/'
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
              location.pathname === '/about'
                ? 'text-primary-500'
                : 'text-foreground-700 hover:text-primary-500'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-foreground-950`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap cursor-pointer">首页</Link>
          {categories.map((cat) => (
            <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap cursor-pointer">
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap cursor-pointer">关于我们</Link>
        </div>
      )}
    </nav>
  );
}